import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
import { OPTION_TYPE } from "Common/dictionaries/optionType";
import find from "lodash/find";
import toString from "lodash/toString";
export const getDefaultNodeImage = (documentObject) => (documentObject === null || documentObject === void 0 ? void 0 : documentObject.IconId) ? documentObjectIconMap[documentObject.IconId] : undefined;
export default (attributeValues, documentObject, defaultIfNotFound = false) => {
    var _a;
    if (!attributeValues || !documentObject)
        return undefined;
    const imageField = find(documentObject.Attributes, ["Type", OPTION_TYPE.IMAGE]);
    const imageFieldValue = imageField
        ? (_a = find(attributeValues, ["Key", imageField.Key])) === null || _a === void 0 ? void 0 : _a.Value
        : undefined;
    const result = imageFieldValue ? toString(imageFieldValue) : undefined;
    return defaultIfNotFound ? result || getDefaultNodeImage(documentObject) : result;
};
